import { IOrderData } from "../../repository/IOrderData";

export const createOrder = (payload: IOrderData) => ({
  type: "@saga/CREATE_ORDER",
  payload,
});
